var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5104 8.89369C5.60724 8.79215 5.72245 8.71156 5.84939 8.65656C5.97632 8.60156 6.11247 8.57324 6.24999 8.57324C6.3875 8.57324 6.52365 8.60156 6.65059 8.65656C6.77752 8.71156 6.89273 8.79215 6.98957 8.89369L11.7604 13.8554C11.8572 13.9569 11.9725 14.0375 12.0994 14.0925C12.2263 14.1475 12.3625 14.1758 12.5 14.1758C12.6375 14.1758 12.7737 14.1475 12.9006 14.0925C13.0275 14.0375 13.1427 13.9569 13.2396 13.8554L18.0104 8.89369C18.1072 8.79215 18.2225 8.71156 18.3494 8.65656C18.4763 8.60156 18.6125 8.57324 18.75 8.57324C18.8875 8.57324 19.0237 8.60156 19.1506 8.65656C19.2775 8.71156 19.3927 8.79215 19.4896 8.89369C19.6836 9.09667 19.7925 9.37124 19.7925 9.65744C19.7925 9.94364 19.6836 10.2182 19.4896 10.4212L14.7083 15.3937C14.1224 16.0023 13.3281 16.3442 12.5 16.3442C11.6719 16.3442 10.8776 16.0023 10.2917 15.3937L5.5104 10.4212C5.31639 10.2182 5.20749 9.94364 5.20749 9.65744C5.20749 9.37124 5.31639 9.09667 5.5104 8.89369Z",
    fill: "#071E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowIcon);
export default __webpack_public_path__ + "static/media/downArrowIcon.39857372dda5c5cc2b7a171b2a9fea09.svg";
export { ForwardRef as ReactComponent };